import { CloseOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Space, Spin } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { StatePieceStatus } from '../../../../../enums';
import { IAddCategoryLookupListFormValues } from '../../../../../interfaces/lookup/category';
import { IAddCategory } from '../../../../../interfaces/lookup/category/data';
import { ContentHeader } from '../../../../../shared/components/appSkeleton/contentHeader/ContentHeader';
import { FetchResult } from '../../../../../shared/components/fetchResult/FetchResult';
import { ROW_GUTTER } from '../../../../../shared/Constants';
import { isError } from '../../../../../shared/helpers';
import { AppDispatch, RootState } from '../../../../../store';
import { addCategory } from '../../../../../store/lookupSlice/LookupActions';

export const CategoryLookupListAdd = () => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const lookupSlice = useSelector((state: RootState) => state.lookupSlice);

    const onFinish = (values: IAddCategoryLookupListFormValues) => {
        const body: IAddCategory = {
            ...(values as any),
        };

        dispatch(addCategory(body));
    };

    useEffect(() => {
        if (lookupSlice.detailsPage.category.createStatus === StatePieceStatus.Success) {
            navigate('/admin/lookup-lists/category', { replace: true });
        }
    }, [lookupSlice.detailsPage.category.createStatus]);

    return (
        <Form
            form={form}
            name="category-lookup-add"
            onFinish={onFinish}
            layout="vertical"
            onValuesChange={(changedValue: any, values) => {
                form.setFieldsValue(values);
            }}
        >
            <ContentHeader
                title="Manage category lookup list"
                breadcrumbs={[
                    {
                        breadcrumbName: 'Admin',
                        path: '/admin',
                    },
                    {
                        breadcrumbName: 'Manage lookup lists',
                        path: '/admin/lookup-lists',
                    },
                    {
                        breadcrumbName: 'Category',
                        path: '/admin/lookup-lists/category',
                    },
                    {
                        breadcrumbName: 'Create',
                        path: `/admin/lookup-lists/category/add`,
                    },
                ]}
            >
                {!isError(lookupSlice.detailsPage.category.fetchStatus) && (
                    <Form.Item>
                        <Space>
                            <Button
                                icon={<CloseOutlined />}
                                onClick={() => navigate(-1)}
                                disabled={
                                    lookupSlice.detailsPage.category.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.category.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Close
                            </Button>
                            <Button
                                htmlType="submit"
                                type="primary"
                                icon={<SaveOutlined />}
                                loading={
                                    lookupSlice.detailsPage.category.updateStatus === StatePieceStatus.IsFetching ||
                                    lookupSlice.detailsPage.category.fetchStatus === StatePieceStatus.IsFetching
                                }
                            >
                                Save and close
                            </Button>
                        </Space>
                    </Form.Item>
                )}
            </ContentHeader>

            <div className="page-content">
                <Spin spinning={lookupSlice.detailsPage.category.fetchStatus === StatePieceStatus.IsFetching}>
                    {isError(lookupSlice.detailsPage.category.fetchStatus) ? (
                        <FetchResult status={lookupSlice.detailsPage.category.fetchStatus} about={'Category'} />
                    ) : (
                        <>
                            <Row>
                                <Col span={24}>
                                    <Space>
                                        <label className="group-label">Category option Information</label>
                                    </Space>
                                </Col>
                            </Row>
                            <Row gutter={ROW_GUTTER}>
                                <Col span={8}>
                                    <label className="property required">Code</label>
                                    <Form.Item name="code" rules={[{ required: true, message: "'Code' is required" }]}>
                                        <Input maxLength={10} />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>
                                    <label className="property required">Description</label>
                                    <Form.Item name="description" rules={[{ required: true, message: "'Description' is required" }]}>
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col span={8}>&nbsp;</Col>
                            </Row>
                        </>
                    )}
                </Spin>
            </div>
        </Form>
    );
};
